import { render, staticRenderFns } from "./Plate.vue?vue&type=template&id=2b4674b0&scoped=true&"
import script from "./Plate.vue?vue&type=script&lang=js&"
export * from "./Plate.vue?vue&type=script&lang=js&"
import style0 from "./Plate.vue?vue&type=style&index=0&id=2b4674b0&lang=scss&scoped=true&"
import style1 from "./Plate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4674b0",
  null
  
)

export default component.exports